import { useContext} from "react";
import "react-grid-layout/css/styles.css";
import "../styles.css";

import { useNavigate, useParams } from "react-router-dom";
import { DashboardContext } from "../../../contexts/Dashboard/DashboardContext";
import Grid from "../Grid";

const DashboardMain = () => {
  const { completeRequisition, dataComponentsInScreen, waitingRedirect } =
    useContext(DashboardContext);
  const { id, mode } = useParams();
  const navigate = useNavigate();

  return completeRequisition && (mode === 'edit' || (dataComponentsInScreen.length > 1 && mode === 'view') ) ? (
    <div className="content-page"  style={{ cursor: waitingRedirect ? 'wait' : 'default' }}>
      <Grid />
    </div>
  ) : mode === "view" && completeRequisition  ? (
    <div className="container">
      <p className="bordered-text">Tela ainda sem gráficos</p>
      <p className="edit-button">
        Abra a{" "}
        <a
          onClick={() => {
            navigate(`/dashboard/edit/${id}`);
          }}
        >
          edição
        </a>{" "}
        da página para adicionar
      </p>
    </div>
  ) : (
    <></>
  );
};

export default DashboardMain;
